import Glider from 'glider-js';

export const init = () => {
	const jsReferencesCarousel = document.querySelectorAll('.js-references-carousel');
	Array.from(jsReferencesCarousel).forEach((item) => {
		const itemCount = item.querySelectorAll('.references__item').length;
		const prevControl = item.nextElementSibling.querySelector('.slider-control__arrow-prev');
		const nextControl = item.nextElementSibling.querySelector('.slider-control__arrow-next');

		if (itemCount > 1) {
			const parent = item.closest('.references__carousel-wrap');
			parent.querySelector('.slider-control').classList.remove('u-hide');
		}

		if (itemCount < 2) {
			item.parentElement.classList.add('references__carousel-wrap--no-controls');
		}

		new Glider(item, {
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: false,
			duration: 0.3,
			arrows: {
				prev: prevControl,
				next: nextControl,
			},
		});
	});
};
